export default __webpack_public_path__ + "static/media/Icon - APPOINTMENT DURATION.f8957c49.svg";